import { HttpHeaders } from '@angular/common/http';

export const options = {
    headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'application/json'
    })
};
